(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    /*
   * Crossfading image gallery: auto-advances on a timer and responds to the prev/next arrows.
   * Pauses while the tab is hidden or the gallery is scrolled out of view.
   */
  class ImageGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.image-block__gallery-slide'));
      if (this.slides.length === 0) return;

      this.index = 0;
      this.slides[0].setAttribute('data-active', '');
      if (this.slides.length < 2) return;

      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      this.next = this.next.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);

      this.querySelector('[data-gallery-prev]').addEventListener('click', (event) => this.step(event, -1));
      this.querySelector('[data-gallery-next]').addEventListener('click', (event) => this.step(event, 1));

      this.observer = new IntersectionObserver((entries) => {
        entries[0].isIntersecting ? this.start() : this.stop();
      });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    }

    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }

    handleVisibilityChange() {
      document.hidden ? this.stop() : this.start();
    }

    start() {
      this.stop();
      this.timer = setInterval(this.next, this.interval);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    step(event, direction) {
      // The block may be wrapped in a link; the arrows must not navigate.
      event.preventDefault();
      event.stopPropagation();
      this.show(this.index + direction);
      // Restart the timer so a manual change gets a full interval.
      if (this.timer) this.start();
    }

    next() {
      this.show(this.index + 1);
    }

    show(index) {
      this.slides[this.index].removeAttribute('data-active');
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides[this.index].setAttribute('data-active', '');
    }
  }

  if (!customElements.get('image-gallery')) {
    customElements.define('image-gallery', ImageGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
